export default __webpack_public_path__ + "static/madura.header-c766d9c732f4890dcbad68cc28c5af40.jpg";